module.exports = __webpack_public_path__ + "7a3d672812459c6be66fd4144e5e0dc3.glb";